import InstrumentIcon from "../../../../components/instrument-icon";
import {useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import {Dropdown, Form, InputGroup} from 'react-bootstrap';
import SvgIcon from "../../../../components/svg-icon";


const DepositCurrencyDropdown = ({selectedCurrency, currencyList, handleChangeWallet}) => {

    const {t} = useTranslation()
    const [currencyListFiltered, setCurrencyListFiltered] = useState([]);
    const [searchTerm, setSearchTerm] = useState('')
    const [show, setShow] = useState(false);
    const dropdownRef = useRef(null);


    useEffect(() => {
        setCurrencyListFiltered(currencyList?.filter(i => i.code?.toUpperCase().includes(searchTerm?.toUpperCase()) || i.name?.toUpperCase().includes(searchTerm?.toUpperCase())))
    }, [currencyList, searchTerm])

    // Handle click outside dropdown
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShow(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [dropdownRef]);


    return (
        <Dropdown
            ref={dropdownRef}
            className="modal__wallet-dropdown modal__wallet-dropdown--double-big"
            show={show}
            onToggle={() => setShow(!show)}
        >
            <Dropdown.Toggle
                className="modal__wallet-dropdown-btn"
                id="modalWallet0"
                aria-expanded={show}
                onClick={() => setShow(!show)}
            >
                <div className="d-flex align-items-center gap-2">
                    <InstrumentIcon code={selectedCurrency?.code}/>
                    {selectedCurrency?.code}
                </div>
                <SvgIcon id={'right-down'}/>
            </Dropdown.Toggle>

            <Dropdown.Menu className="modal__wallet-menu" aria-labelledby="modalWallet0">
                <div className="modal__wallet-search">
                    <div className="search">
                        <InputGroup>
                            <Form.Control
                                value={searchTerm}
                                onChange={e => setSearchTerm(e.target.value)}
                                type="text"
                                className="search__input"
                                placeholder={t('general.search')}
                            />
                        </InputGroup>
                    </div>
                </div>

                <ul className="modal__wallet-currencies">
                    {/*<li*/}
                    {/*    onClick={() => {*/}
                    {/*        handleChangeWallet({code: 'TRY'});*/}
                    {/*        setShow(false); // Close dropdown on item click*/}
                    {/*    }}>*/}
                    {/*          <span className="gapp2">*/}
                    {/*            <InstrumentIcon code={'TRY'}/>*/}
                    {/*              TRY*/}
                    {/*          </span>*/}
                    {/*</li>*/}

                    {currencyListFiltered?.map((wall, i) => (
                        <li
                            key={i}
                            onClick={() => {
                                handleChangeWallet(wall);
                                setShow(false); // Close dropdown on item click
                            }}
                        >
                              <span className="gapp2">
                                <InstrumentIcon code={wall?.code}/>
                                  {wall?.code}
                              </span>
                        </li>
                    ))}
                </ul>
            </Dropdown.Menu>
        </Dropdown>
    )

}


export default DepositCurrencyDropdown
